var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.$_.get(_vm.$_.last(_vm.navigation.parentFlows), "id"),
      staticClass: "flow-bread-crumb",
    },
    [
      _vm.navigation.parentFlows.length
        ? _c(
            "div",
            { staticClass: "breadcrumb-container" },
            [
              _c(
                "div",
                { staticClass: "item" },
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "20px" },
                    attrs: { type: "home" },
                    on: {
                      click: function ($event) {
                        return _vm.navigateAndFocus()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "divider" }, [_vm._v(" > ")]),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(
                _vm.$_.reverse(_vm.navigation.parentFlows),
                function (item) {
                  return _c(
                    "div",
                    {
                      key: item.block.id,
                      staticClass: "item",
                      on: {
                        click: function ($event) {
                          return _vm.navigateAndFocus(item.block)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(item.block.name || _vm.$t("chatbotv2.flow"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "divider" }, [_vm._v(" > ")]),
                    ]
                  )
                }
              ),
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "title" },
            [
              _c("StoryTitle", {
                attrs: { storyTitle: _vm.title, storyId: _vm.storyId },
              }),
              _vm._v(" "),
              _vm.previewMode
                ? _c("span", { staticClass: "text-primary" }, [
                    _vm._v("(Preview Mode)"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.previewMode
                ? _c("span", { staticClass: "text-danger" }, [
                    _vm._v("v:" + _vm._s(_vm.board.version)),
                  ])
                : _vm._e(),
            ],
            1
          ),
      _vm._v(" "),
      _c("TrainingPanel", { attrs: { showAIKnowledge: _vm.showAIKnowledge } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }